import { render, staticRenderFns } from "./Facility.vue?vue&type=template&id=08b14658&scoped=true&lang=pug"
import script from "./Facility.vue?vue&type=script&lang=ts"
export * from "./Facility.vue?vue&type=script&lang=ts"
import style0 from "./Facility.vue?vue&type=style&index=0&id=08b14658&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b14658",
  null
  
)

export default component.exports